import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { riseIn, spring } from '../motion';

interface Props {
  n: number;
  title: string;
  done?: boolean;
  aside?: React.ReactNode;
  children: React.ReactNode;
}

/** 作る画面の1段。決まると番号がチェックに変わる。 */
export const Step: React.FC<Props> = ({ n, title, done, aside, children }) => (
  <motion.section className="v2-card v2-step" variants={riseIn} layout="position">
    <div className="v2-step-head">
      <span className="v2-step-num" data-done={done ? 'true' : 'false'}>
        <AnimatePresence mode="wait" initial={false}>
          {done ? (
            <motion.span key="ok" initial={{ scale: 0, rotate: -90 }} animate={{ scale: 1, rotate: 0 }} exit={{ scale: 0 }} transition={spring} style={{ display: 'grid' }}>
              <Check size={15} strokeWidth={3.2} />
            </motion.span>
          ) : (
            <motion.span key="n" initial={{ scale: 0 }} animate={{ scale: 1 }} exit={{ scale: 0 }}>
              {n}
            </motion.span>
          )}
        </AnimatePresence>
      </span>
      <span className="v2-step-title">{title}</span>
      {aside}
    </div>
    {children}
  </motion.section>
);

interface SummaryProps {
  preview: React.ReactNode;
  rows: Array<[string, React.ReactNode]>;
  children?: React.ReactNode;
}

/** 右側の確認カード。値が変わると行がふわっと入れ替わる。 */
export const SummaryCard: React.FC<SummaryProps> = ({ preview, rows, children }) => (
  <motion.aside className="v2-card v2-summary" variants={riseIn}>
    <div className="v2-summary-preview">{preview}</div>
    <dl className="v2-kv">
      {rows.map(([k, v]) => (
        <div className="v2-kv-row" key={k}>
          <dt>{k}</dt>
          <AnimatePresence mode="popLayout" initial={false}>
            <motion.dd
              key={typeof v === 'string' || typeof v === 'number' ? String(v) : k}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.2 }}
            >
              {v}
            </motion.dd>
          </AnimatePresence>
        </div>
      ))}
    </dl>
    {children}
  </motion.aside>
);
